import type { AppState } from 'types/app';
import { isEuUser, isWebViewRequest } from 'helpers/Cookie';

export const selectCookies = (state: AppState) => state.cookies;

export const selectCookie = (state: AppState, key: string): string => selectCookies(state)?.[key] || '';

export const selectCookiesSessionId = (state: AppState) => selectCookie(state, 'session-id');

export const selectIsWebViewRequest = (state: AppState): boolean => isWebViewRequest(selectCookies(state));

export const selectIsEuUser = (state: AppState): boolean => isEuUser(selectCookies(state));
